<template>
  <section class="vbox">
    <section class="scrollable padder">
      <Breadcrumb :items="breadcrumbList"/>
      <ListFilter title="Payment Term" @show-form="showForm"/>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Payment Term
          </h4>
        </template>
        <template #body>
          <AddPaymentTerm
            :termId="termId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  PAYMENT TERMS
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    width=""
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Payment Term</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in termList"
                        :key="item.term_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ item.term_name }}</td>
                        <td>
                          <a
                            v-on:click="showForm(item.term_id)"
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddPaymentTerm from "../components/AddPaymentTerm.vue";
import PanelModal from "../components/PanelModal.vue";
import Breadcrumb from "../components/Breadcrumb.vue";
import ListFilter from "../components/ListFilter.vue";

export default {
  name: "PaymentTerm",

  components: {
    Breadcrumb,
    AddPaymentTerm,
    PanelModal,
    ListFilter
},
  data() {
    return {
      breadcrumbList: [{title: 'Home', link: '#', icon: 'fa fa-dashboard', active: false },{title: 'Payment Terms', link: false, icon: false, active: true }],
      showFormModal: false,
      baseUrl: this.$store.state.baseURL,
      termList: {},
      termId: "",
      StatusActive: true,
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_payment_terms", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.termList = response.data.values;
          } else {
            this.termList = data.termList;
          }
        });
    },
    showForm: function(id = '') {
      this.termId = id;
      this.showFormModal = true;
    },
  },
  mounted(){
    this.getList()
  }
};
</script>
